export default __webpack_public_path__ + "static/media/person3.32086b69.jfif";